<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('RailwayExport.ReturnContainer')"
    width="370px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-row">
      <el-form label-width="80px" label-position="left">
        <el-form-item :label="$t('RailwayExport.ReturnBoxDate')+':'">
          <el-date-picker v-model="returnBoxDate" type="date" value-format="yyyy-MM-dd" clearable />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="display: flex;">
      <div style="margin: 0 auto;">
        <el-button no="Confirm" type="primary" @click="successHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="Cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { returnBox } from '@/api/railwayExport/railwayContainer'

export default {
  name: 'ReturnBoxDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: false },
    selectList: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      returnBoxDate: ''
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
      },
      immediate: true
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.returnBoxDate = ''
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    successHandler() {
      if (this.selectList.length === 0) {
        this.$message.info(this.$t('RailwayExport.PleaseEnterContainerInformation'))
        return
      }
      if (!this.returnBoxDate) {
        this.$message.info(this.$t('RailwayExport.PleaseEnterReturnContainerTime'))
        return
      }
      const object = {
        returnBoxDate: this.returnBoxDate,
        jobKey: this.job.uuid,
        jobNo: this.job.jobNo,
        sList: this.selectList.reduce((a, b) => a + ',' + b)
      }
      returnBox(object).then(res => {
        this.$emit('successCallback')
        this.innerVisible = false
        this.$message.success(this.$t('RailwayExport.ReturnSuccessfulSuccessfulReturnCount') + res.data)
      })
    }
  }
}
</script>

<style>
</style>
